export default __webpack_public_path__ + "static/media/home-count.5dbe0998.svg";